import { connect } from 'react-redux';
import Commons from 'js/helpers/Commons';
import { isAU } from 'js/constants/crux';
import UndisclosedSales from 'js/components/common/undisclosedSales/UndisclosedSales';

export const _UndisclosedSales = (props) => {
    const {
        usrDetail, isPriceWithheld, showUndisclosed, ...rest
    } = props;
    const undisclosedSalesRole = 'Undisclosed Sales Access';

    let undisclosedSalesAccess = showUndisclosed;
    if (!showUndisclosed) {
        const entitlementsRoles = Commons.get(usrDetail, 'entitlements.roles');
        undisclosedSalesAccess = entitlementsRoles && entitlementsRoles
            .includes(undisclosedSalesRole);
    }

    // NZ is not withholding price
    return (
        <UndisclosedSales
            {...rest}
            undisclosedSalesAccess={undisclosedSalesAccess}
            isPriceWithheld={isPriceWithheld && isAU}
        />
    );
};

const UndisclosedSalesWithConnect = connect(state => ({
    undisclosedSalesFeature: state.launchDarkly.get('featureFlag')['crux.undisclosed.sales'],
    usrDetail: state.clapi.get('usrDetail'),
}))(_UndisclosedSales);
UndisclosedSalesWithConnect.displayName = 'UndisclosedSalesWithConnect';

export default UndisclosedSalesWithConnect;
